module.exports = __webpack_public_path__ + "media/images/application/icons/icon-mark-665c586b2a8317bda1425d555ba8fffa.svg";